import React from 'react';
import { Logo } from '../../atoms';
import LogoBase from '../../assets/img/LOGO_RGB.png';
import {
    MaintenanceContainer,
    MaintenanceBox,
    LogoContainer,
    Title,
    FinePrint,
    Message,
    Footer
} from './style';

const MaintenancePage = () => {
    return (
        <MaintenanceContainer>
            <MaintenanceBox>
                <LogoContainer>
                    <Logo size={Logo.SIZE.MEDIUM} src={LogoBase} />
                </LogoContainer>

                <Title>
                    LEA is no longer available.
                    <br />
                    #learn, the new learning platform replacing LEA, will be available from 28 September.
                    <br />
                    <FinePrint>
                        Please refer to the dedicated communications for access information.
                    </FinePrint>
                </Title>
            </MaintenanceBox>
        </MaintenanceContainer>
    );
};

export default MaintenancePage;